export default {"src":"/_next/static/media/b-capital-group-logo.6319787f.svg","height":19,"width":175,"blurWidth":0,"blurHeight":0};